export default __webpack_public_path__ + "static/media/doc.12fb1a55.png";